import Vue from 'vue'
import Router from 'vue-router'

// views
import Home from './views/Home.vue'
import Presentation from './views/Presentation.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '',
      name: 'home',
      component: Home,
    },
    {
      path: '/:id',
      name: 'Presentation',
      component: Presentation,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})
